import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";
import AlertService from "@/core/services/alert.service";
// action types
export const UPDATE_PERSONAL_INFO = "updateUserPersonalInfo";
export const UPDATE_ACCOUNT_INFO = "updateUserAccountInfo";
export const GET_PERSONAL_INFO = "getUserPersonalInfo";

// mutation types
export const SET_PERSONAL_INFO = "setPersonalInfo";
export const SET_ACCOUNT_INFO = "setAccountInfo";
export const SET_PERSONAL_INFO_ERROR = "setPersonalInfoError";
export const CLEAR_PERSONAL_INFO_ERROR = "clearPersonalInfoError";

const state = {
    /*user_personal_info: {
        photo: "media/users/300_21.jpg",
        name: "James",
        surname: "Jones",
        company_name: "Fifestudios",
        job: "Application Developer",
        email: "matt@fifestudios.com",
        phone: "44(76)34254578",
        company_site: "fifestudios"
    },*/
    errors: [],
    user_personal_info: {
        //name: "Levent Özduru",
        //email: "levozduru@hotmail.com",
        //photo: "media/users/300_21.jpg"
    },
    user_account_info: {
        username: "nick84",
        email: "nick.watson@loop.com",
        language: "English",
        time_zone: "(GMT-11:00) Midway Island",
        communication: {
            email: true,
            sms: true,
            phone: false
        },
        verification: true
    },
    
};

const getters = {
    currentUserPersonalInfo(state) {
       
        return state.user_personal_info;
    },

    currentUserAccountInfo(state) {
        return state.user_account_info;
    },

    currentUserPhoto(state) {
        return state.user_personal_info.photo;
    },

    
};

const actions = {

    [UPDATE_PERSONAL_INFO](context, payload) {
        context.commit(CLEAR_PERSONAL_INFO_ERROR);
        return ApiService.put(`/auth/update-profile/${payload.id}`, payload)
        .then((response) => {
            
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde güncelleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else{
                AlertService.makeToast(
                    "success",
                    "Güncelleme Başarılı",
                    "Kişisel bilgileriniz başarıyla güncellenmiştir."
                );
            
            return response;   
            }
                
        })
        .catch(({ response }) => {
            context.commit(SET_PERSONAL_INFO_ERROR, response.data.errors);
            AlertService.makeToast(
                "danger",
                "Hata!",
                "Lütfen aşağıdaki hataları düzeltiniz veya eksiklikleri gideriniz."
            );
        });
        
    },

    [UPDATE_ACCOUNT_INFO](context, payload) {
        context.commit(SET_ACCOUNT_INFO, payload);
    },
    [GET_PERSONAL_INFO](context) {
        JwtService.getToken();
        ApiService.setHeader();
        ApiService.get("/auth/user-profile").then(({ data }) => {
            context.commit(SET_PERSONAL_INFO, data);
        });
    },

    
};

const mutations = {
    [SET_PERSONAL_INFO](state, user_personal_info) {
        state.user_personal_info = user_personal_info;
    },
    [SET_ACCOUNT_INFO](state, user_account_info) {
        state.user_account_info = user_account_info;
    },

    [SET_PERSONAL_INFO_ERROR](state, error) {
        state.errors = error;
    },

    [CLEAR_PERSONAL_INFO_ERROR](state) {
        state.errors = [];
    },
    
};

export default {
    state,
    actions,
    mutations,
    getters
};
